import 'reflect-metadata';
import { Vue, Component } from 'vue-property-decorator';
import Constants from '@/assets/ts/configuration/Constants';
import axios from 'axios';
import LoginController from '@/assets/ts/controller/LoginController';
import PopupController from '@/assets/ts/controller/PopupController';
import Util from '@/assets/ts/utils/Util';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

const url = Constants.PROJECT_PATH;
const loginBackend = Constants.LOGIN_BACKEND_PATH;

@Component({
  name: 'Login',
  components: {
  },
})
class Login extends Vue {
  // #region [ DATA ]
  public loginZeedhi = {
    name: 'Login',
    component: 'ZdLogin',
    backgroundStyle: '#195DA9',
    logoMessage: 'Portal do Gestor',
    poweredByImage: 'gestao1.png',
    logo: `logo.png`,
    layout: 'left',
    children: [
      {
        name: 'email',
        component: 'ZdTextInput',
        label: 'Usuário',
        events: {
          keydown: this.emailOnTab,
        },
        id: 'login_email',
        validations: {
          required: {
            message: "Campo obrigatório",
          },
        },
      },
      {
        name: 'password',
        component: 'ZdPassword',
        label: 'Senha',
        id: 'login_password',
      },
      {
        name: 'basicUsageForm',
        component: 'ZdForm',
        align: 'center',
        children: [
          {
            name: 'loginButton',
            component: 'ZdButton',
            label: 'Entrar',
            color: 'primary',
            events: {
              click: (res: any) => this.handleClick(res),
            },
          },
          {
            name: 'forgotPassword',
            component: 'ZdButton',
            label: 'Esqueceu sua senha?',
            flat: true,
            events: {
              click: (res: any) => this.forgotPasswordHandleClick(res),
            },
          },
        ],
      },
      {
        name: 'basicUsageForm',
        component: 'ZdForm',
        align: 'end',
        justify: 'end',
        children: [
          {
            name: "handleClickPrivacyPolicy",
            component: "ZdButton",
            label: "Política de Privacidade",
            cssClass: "my-2",
            flat: true,
            events: {
              click: (res: any) => this.handleClickPrivacyPolicy(res),
            },
          },
        ],
      },
    ],
  };

  private messages = {
    invalidLogin: 'Não foi possível realizar o login. Por favor tente novamente mais tarde',
  }

  private privacyPolicy = "";

  private dialogPrivacyPolicy = false;

  // #endregion

  // #region [ METHODS ]
  public buttonSignInClick()  {
    const buttonName = 'loginButton';
    this.buttonClick(buttonName);
  }

  private buttonClick(name: string) {
    (document.querySelector(`button[name=${name}]`) as HTMLButtonElement).click();
  }

  private handleClick(res: any) {
    const fields = Util.getFieldsByZeedhiComponent(res);
    this.login(fields.email, fields.password);
  }

  private async login(email: string, password: string) {
    try {
      const loginResponse = await LoginController.login(email, password);

      if (!loginResponse.login) {
        const message = loginResponse.message ? loginResponse.message : this.messages.invalidLogin;
        SnackbarUtils.showMessage(message, loginResponse.type ? loginResponse.type : SnackbarUtils.TYPE_ERROR);
      }
    } catch (err) {
      const message = err.message;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private emailOnTab(ev) {
    if (ev.event.code === 'Tab') {
      this.focusPasswordField();
      ev.event.preventDefault();
    }
  }

  private focusPasswordField() {
    const passwordComponent = document.getElementById('login_password');
    const fieldComponent = passwordComponent.children[0].children[0].children[0].children[1];

    (fieldComponent as any).focus();
    (fieldComponent as any).select();
  }

  private forgotPasswordHandleClick(res: any) {
    const fields = Util.getFieldsByZeedhiComponent(res);
    const email = fields.email ? fields.email : '';
    if (!email) {
      SnackbarUtils.showMessage('Preencha o Usuário para prosseguir com o processo!',  SnackbarUtils.TYPE_ALERT);
      return;
    }
    
    LoginController.forgotPasswordPopupHandler(email);
  }

  private async handleClickPrivacyPolicy(res: any) {
    const fields = Util.getFieldsByZeedhiComponent(res);
    const email = fields.email ? fields.email : "";

    if (!email) {
      SnackbarUtils.showMessage('Preencha o Usuário para visualizar a política de privacidade!',  SnackbarUtils.TYPE_ALERT);
      return;
    }

    try {
      this.privacyPolicy = await LoginController.findPrivacyPolicyByAuthentication(email);
      this.dialogPrivacyPolicy = true;
    } catch (err) {
      throw err;
    }
  }

  // #endregion
}

export default Login;